<yat-solution-download id="fdae39dd-91f7-499d-9524-b1ed3cbe2318" [product]="product$ | async"> </yat-solution-download>
<div class="row mb-0">
  <div class="col-12">
    <button yat-button type="button" class="btn btn-large primary w-100" (click)="close()">{{ 'close' | commonWording | async }}</button>
  </div>
</div>
